"use strict";
import React from "react";

class OpsFooter extends React.Component {
    render() {
        const appContext = this.props.appContext;
        return (
            <footer></footer>
        );
    }
};

module.exports = OpsFooter;
